import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import {
  ContainerDivs,
  Link,
  LinkIcon,
} from '../../components'

const Styles = require('./IyvBanner.css')

@CSSModules(Styles, {allowMultiple:true})
export default class IyvBanner extends Component {
  render() {
    // const link = config.domain
    // const message = config.shareMessage

    const fffIcon = require( '../../../static/images/icons/fff-icn-clr.png' )
    const dffIcon = require( '../../../static/images/icons/dff-icn-clr.png' )
    const gefIcon = require( '../../../static/images/icons/gef-icn-clr.png' )
    const sjfIcon = require( '../../../static/images/icons/sjf-icn-clr.png' )
    const gffIcon = require( '../../../static/images/icons/gff-icn-clr.png' )
    const pffIcon = require( '../../../static/images/icons/pff-icn-clr.png' )
    const wffIcon = require( '../../../static/images/icons/wff-icn-clr.png' )
    const tffIcon = require( '../../../static/images/icons/tff-icn-clr.png' )
    const rpsIcon = require( '../../../static/images/icons/rps-icn-clr.png' )
    // rps = retirement plan scorecard

    const iconConfig = [
      { 
        icn: fffIcon,
        stl: 'fff',
        url: 'https://fossilfreefunds.org',
        name: 'Fossil Free Funds'
      },
      {
        icn: dffIcon,
        stl: 'dff',
        url: 'https://deforestationfreefunds.org',
        name: 'Deforestation Free Funds'
      },
      {
        icn: sjfIcon,
        stl: 'sjf',
        url: 'https://socialjusticefunds.org',
        name: 'Social Justice Funds'
      },
      {
        icn: gefIcon,
        stl: 'gef',
        url: 'https://genderequalityfunds.org',
        name: 'Gender Equality Funds'
      },
      {
        icn: wffIcon,
        stl: 'wff',
        url: 'https://weaponfreefunds.org',
        name: 'Weapon Free Funds'
      },
      {
        icn: pffIcon,
        stl: 'pff',
        url: 'https://prisonfreefunds.org',
        name: 'Prison Free Funds'
      },
      {
        icn: gffIcon,
        stl: 'gff',
        url: 'https://gunfreefunds.org',
        name: 'Gun Free Funds'
      },
      {
        icn: tffIcon,
        stl: 'tff',
        url: 'https://tobaccofreefunds.org',
        name: 'Tobacco Free Funds'
      },
      {
        icn: rpsIcon, 
        stl: 'rps',
        url: 'https://investyourvalues.org',
        name: 'Retirement Plan Scorecard'
      }
    ]

    // STYLE NOTES:
    // hmi == HomeMoreIyv
    return (
      <div styleName='hmi-img-bckgrnd'>
        <ContainerDivs>
          <div styleName='hmi-hl'>
            More from Invest Your Values
          </div>
          <div styleName='hmi-tl'>
            See how mutual funds and ETFs are rated on issues ranging from
            fossil fuels, to deforestation, gender equality, guns, prisons,
            weapons, and tobacco
          </div>

          <div styleName='hmi-icns'>
            { /* */
              iconConfig.map((e, i) => {
                // some sites end in Funds others don't
                const nm = e.name.split(' ')
                const nmStart = nm.slice(0,2).join(' ')
                const nmEnd = nm.slice(2)
                //
                return (
                  <div
                    styleName='hmi-icn-out'
                    key={'hmi-icn-' + i}
                  >
                    <Link
                      to={e.url}
                      title={e.name}
                    >
                      <div styleName='hmi-icn-in'>
                        <img
                          src={e.icn}
                          alt={e.name}
                        />
                        <div styleName='hmi-icn-lbl'>
                          <span styleName={e.stl}>{nmStart}</span>
                          <span>&nbsp;{nmEnd}</span>
                        </div>
                      </div>
                    </Link>
                  </div>
                )
              })
            }
          </div>

          <div styleName='hmi-lnk'>
            <Link
              to={config.links.aysinvest}
              title='Learn more about Invest Your Values'
              xstrong
            >
              Learn more about Invest Your Values<LinkIcon/>
            </Link>
          </div>
        </ContainerDivs>
      </div>
    )
  }
}

